
import  axios  from 'axios';
//import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore} from "../towjob/actions";
//import {loadFaxDataInStore} from "../fax/actions";


export const LOAD_EMAIL_DATA = 'email/LOAD_EMAIL_DATA';
export const DELETE_A_EMAIL = 'email/DELETE_A_EMAIL';
export const SAVE_A_EMAIL = 'email/SAVE_A_EMAIL';
export const UPDATE_A_EMAIL = 'email/UPDATE_A_EMAIL';
export const LOAD_TOW_EMAIL_DATA = 'email/LOAD_TOW_EMAIL_DATA';

export const SET_EMAIL_STATUS_FILTER = 'email/SET_EMAIL_STATUS_FILTER';
export const SET_EMAIL_VIN_FILTER = 'email/SET_EMAIL_VIN_FILTER';
export const SET_EMAIL_PLATE_FILTER = 'email/SET_EMAIL_PLATE_FILTER';
export const SET_EMAIL_STARTTIME_FILTER = 'email/SET_EMAIL_STARTTIME_FILTER';
export const SET_EMAIL_ENDTIME_FILTER = 'email/SET_EMAIL_ENDTIME_FILTER';
export const SET_EMAIL_EMAIL_ADDRESS_FILTER = 'email/SET_EMAIL_EMAIL_ADDRESS_FILTER';
export const SET_EMAIL_RECIPIENT_FILTER = 'email/SET_EMAIL_RECIPIENT_FILTER';
export const SET_CLEAR_ALL_FILTER = 'email/SET_CLEAR_ALL_FILTER';
export const CLEAR_A_EMAIL_ERROR_MESSAGE = 'email/CLEAR_A_EMAIL_ERROR_MESSAGE';


export function clearEmailErrorMsgInStore(){
    return {
        type: CLEAR_A_EMAIL_ERROR_MESSAGE,
        
    }
}

export function loadTowEmailDataInStore(argEmailDataArray) {
    return {
        type: LOAD_TOW_EMAIL_DATA,
        towEmailsData:argEmailDataArray
    }
}

export function loadEmailDataInStore(argEmailDataArray) {
    return {
        type: LOAD_EMAIL_DATA,
        emailsData:argEmailDataArray
    }
}
export function deleteAEmailInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_EMAIL,
        deleteEmailResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveAEmailDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_EMAIL,
        saveEmailResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateAEmailDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_EMAIL,
        updateEmailResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function setEmailStatusFilterInStore(argFilter ) {
    return {
        type: SET_EMAIL_STATUS_FILTER,
        emailStatusFilter:argFilter,
    }
}

export function setEmailEmailAddressFilterInStore(argFilter ) {
    return {
        type: SET_EMAIL_EMAIL_ADDRESS_FILTER,
        emailEmailAddressFilter:argFilter,
    }
}

export function setEmailVinFilterInStore(argFilter ) {
    return {
        type: SET_EMAIL_VIN_FILTER,
        emailVinFilter:argFilter,
    }
}

export function setEmailPlateFilterInStore(argFilter ) {
    return {
        type: SET_EMAIL_PLATE_FILTER,
        emailPlateFilter:argFilter,
    }
}


export function setEmailRecipientNameFilterInStore(argFilter ) {
    return {
        type: SET_EMAIL_RECIPIENT_FILTER,
        emailRecipientNameFilter:argFilter,
    }
}

export function setEmailStartTimeFilterInStore(argFilter ) {
    return {
        type: SET_EMAIL_STARTTIME_FILTER,
        emailStartTimeFilter:argFilter,
    }
}

export function setEmailEndTimeFilterInStore(argFilter ) {
    return {
        type: SET_EMAIL_ENDTIME_FILTER,
        emailEndTimeFilter:argFilter,
    }
}

export function clearAllFiltersInStore() {
    return {
        type: SET_CLEAR_ALL_FILTER,
       
    }
}


/********************* End of InStore calls **************************/
//****************************************
//Add Email to the Emails Array
//****************************************
export function addEmailToEmailsArray(argEmail ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempEmailsArray=[] ;
        tempEmailsArray = Object.assign(tempEmailsArray,state.email.emailsArray);
        //adding to the top of the array.
        tempEmailsArray.unshift(argEmail);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadEmailDataInStore(tempEmailsArray));
    }//end of return
}

//****************************************
//Delete Email from the Emails Array
//****************************************
export function deleteEmailFromEmailsArray(argEmailId ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempEmailsArray=[] ;
        tempEmailsArray = Object.assign(tempEmailsArray,state.email.emailsArray);
        //removig the match element with the matching id.
        let newArray = tempEmailsArray.filter(element => { return element.id != argEmailId });
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadEmailDataInStore(newArray));
    }//end of return
}
//****************************************
//update Email in the Emails Array
//****************************************
export function updateEmailInEmailsArray(argEmail ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempEmailsArray=[] ;
        tempEmailsArray = Object.assign(tempEmailsArray,state.email.emailsArray);
        //rempoving the item from the array and then add the updated one to the array array.
        let newArray = tempEmailsArray.filter(element => { return element.id != argEmail.id });
        //adding to the top of the array.
        newArray.unshift(argEmail);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadEmailDataInStore(newArray));
    }//end of return
}



//****************************************
//Below is for update a Stream
//****************************************
export function clearEmailErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearEmailErrorMsgInStore());
    }
}
export function updateAEmail(argURL, argCamera, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        updateAEmailOnServer(argURL, argCamera, argCompanyId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(updateAEmailDataInStore(saveResponse, {}));

        }, function(err){
            console.log("I had an error saving a company" + err.response.data);
            dispatch(updateAEmailDataInStore({}, err.response.data));
        });
    }//end of return
}


function updateAEmailOnServer( argURL, argCamera, argCompanyId ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateAEmail(argURL, argCamera, argCompanyId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on saving a StorageLot " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateAEmail(argURL, argEmail,argCompanyId ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/emails" ;
    console.log(" on posting a email the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argEmail ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAEmail(argURL, argEmailInfo, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        saveAEmailOnServer(argURL, argEmailInfo, argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveAEmailDataInStore(saveResponse, {}));

        }, function(err){
            console.log("I had an error saving a storage lot" + err.response.data);
            dispatch(saveAEmailDataInStore({}, err.response.data));
        });
    }//end of return
}


function saveAEmailOnServer( argURL, argEmailInfo, argCompanyId  ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveAEmail(argURL, argEmailInfo, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on saving a email " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveAEmail(argURL, argCamera, argCompanyId ,argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobs/"+argCamera.towId+"/emails";
    console.log(" on posting a email the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteAEmail(argURL, argCameraId, argCompanyId ) {
    return (dispatch, getState) => {
        const state = getState();
        deleteAEmailOnServer(argURL, argCameraId,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){

            dispatch(deleteAEmailInStore(deleteResponse, null));

        }, function(err){
            console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteAEmailInStore({}, err));
        });
    }//end of return
}


function deleteAEmailOnServer( argURL, argStreamId,argCompanyId,  argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteAEmail(argURL, argStreamId, argCompanyId , argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a Email " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteAEmail(argURL, argRealCompanyId, argStorageId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies"+"/"+argRealCompanyId+"/emails/"+argStorageId;
    console.log(" on deleteing a Email the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of Emails

export function loadEmailsData(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfEmails(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){

            dispatch(loadEmailDataInStore(companysList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfEmails(argURL,argCompanyId ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobs/emails";
    console.log(" on getting list of Emails  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfEmails( argURL, argCompanyId ,argIdToken, argUserId ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfEmails(argURL, argCompanyId ,argIdToken, argUserId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}

//Load emails with filter
export function loadEmailsDataWithFilter(argURL, argCompanyId, argFilter) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfEmailsWithFilter(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id, argFilter).then(function(companysList){
            
            dispatch(loadEmailDataInStore(companysList));
            
        }, function(err){
            console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfEmailsWithFilter(argURL,argCompanyId ,argIdToken, argUserId,argFilter  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */
    
    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobs/emails"+argFilter;
    console.log(" on getting list of Emails  the URL is " + baseUrl );
    
    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfEmailsWithFilter( argURL, argCompanyId ,argIdToken, argUserId, argFilter){
    
    var returnPromise = new Promise(function(resolve, reject){
        
        var arrayOfGets = [];
        
        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfEmailsWithFilter(argURL, argCompanyId ,argIdToken, argUserId , argFilter)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });
    
    return returnPromise;
}
//This is for getting email related to one tow job.

export function loadTowEmailsDataWithFilter(argURL, argCompanyId, argTowId) {
    var filter = "?towid="+argTowId;
    return (dispatch, getState) => {
        const state = getState();
        getListOfEmailsWithFilter(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id, filter).then(function(companysList){
            
            dispatch(loadTowEmailDataInStore(companysList));
            
        }, function(err){
            console.log("I had an error gettting Tow Emails" + err);
        });
    }//end of return
}



export function setEmailStatusFilter(argStatus){
    return (dispatch) => {
        dispatch(setEmailStatusFilterInStore(argStatus));
    }
}


export function setEmailEmailAddressFilter(argStatus){
    return (dispatch) => {
        dispatch(setEmailEmailAddressFilterInStore(argStatus));
    }
}

export function setEmailVinFilter(argStatus){
    return (dispatch) => {
        dispatch(setEmailVinFilterInStore(argStatus));
    }
}

export function setEmailPlateFilter(argStatus){
    return (dispatch) => {
        dispatch(setEmailPlateFilterInStore(argStatus));
    }
}

export function setEmailRecipientNameFilter(argStatus){
    return (dispatch) => {
        dispatch(setEmailRecipientNameFilterInStore(argStatus));
    }
}

export function setEmailStartTimeFilter(argStatus){
    return (dispatch) => {
        dispatch(setEmailStartTimeFilterInStore(argStatus));
    }
}
export function setEmailEndTimeFilter(argStatus){
    return (dispatch) => {
        dispatch(setEmailEndTimeFilterInStore(argStatus));
    }
}


export function clearAllFilters(){
    return (dispatch) => {
        dispatch(clearAllFiltersInStore());
    }
}
